import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


import CreateEdit from 'views/Adjustments/CreateEdit'
import Form from 'views/Adjustments/Form'
import List from 'views/Adjustments/List'


class Adjustments extends React.Component {
  render() {
    const {match}=this.props;
    return (
          <Switch>
            <Route path={`${match.path}/add`} component={CreateEdit}/>
            <Route path={`${match.path}/:id`} component={Form}/>
            <Route component={List}/>
          </Switch>
    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(Adjustments);



// WEBPACK FOOTER //
// ./src/views/Adjustments/Adjustments.jsx